import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { specialtySlug, stateNameSlug, stateFromNameSlug } from "@/lib/seo-slugs";
import { stateFromSlug } from "@/lib/us-states";

// ponytail: 301 redirect shim — old URL was /specialty/{sp}/state/{code}, new is /specialty/{sp}/doctors/{stateName}
export const Route = createFileRoute("/specialty/$specialty/state/$state")({
 loader: ({ params }) => {
 const state = stateFromSlug(params.state) ?? stateFromNameSlug(params.state);
 if (!state) throw notFound();
 throw redirect({
 to: "/specialty/$specialty/doctors/$state",
 params: { specialty: specialtySlug(params.specialty), state: stateNameSlug(state.name) },
 statusCode: 301,
 });
 },
 component: () => null,
});
